// extracted by mini-css-extract-plugin
export default {"avatar":"IzuytZ","withBorder":"iys_6I","filter":"qnNIRR"};